import React from "react";
import { createRoot } from "react-dom/client";
import theme from "./lib/theme/theme";
import "./lib/theme/style.css";
import { RouterProvider } from "react-router";
import router from "./lib/router/router";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";
import { MsalProvider } from "@azure/msal-react";
import instanceMSAL from "./lib/auth/authConfig";

function Index() {
	return (
		<MsalProvider instance={instanceMSAL}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<RouterProvider router={router} />
			</ThemeProvider>
		</MsalProvider>
	);
}

const rootDom = document.getElementById("root");
const root = createRoot(rootDom);
root.render(<Index />);
